export default "__VITE_ASSET__AZq2I$rZ__"